export default __webpack_public_path__ + "static/media/moon.ed92601d.svg";